import ResellerContainer from "./ResellerContainer";

export default ResellerContainer;
